<template>
  <div class="wrap" ref="wrap">
    <a-space direction="vertical" style="width:100%" size="middle">
      <a-row type="flex">
        <a-space>
          <a-space>
            <span>用户名: </span>
            <a-input placeholder="输入用户名模糊查询" style="width: 200px" v-model="fuzzyMap.name"
              @keyup.enter.native="search" />
          </a-space>
          <a-space>
            <a-button type="primary" @click="search">搜索</a-button>
            <a-button type="primary" @click="reset">重置</a-button>
            <a-button type="primary" @click="createStaff()">新增员工</a-button>
            <a-button type="primary" @click="openDeleteMoDal()">删除</a-button>
          </a-space>
        </a-space>
      </a-row>

      <a-table :columns="columns" :data-source="data" size="small" :scroll="tableScroll"
        :rowKey="(record) => record.staffId" :loading="loading" :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"  :pagination="false">
        <!-- <template slot="enabled" slot-scope="render">
          <a-tag :color="render == 0 ? 'green' : 'red'">
            {{ render == 0 ? "启用中" : "未启用" }}
          </a-tag>
        </template> -->
        <template slot="gender" slot-scope="render">
          {{ render == 1 ? "男" : "女" }}
        </template>

        <div slot="action" slot-scope="render">
          <a @click="toResetPassword(render.staffId)">重置密码</a>
          <a-divider type="vertical" />
          <a @click="modifyStaff(render)">修改</a>
          <!-- <a-divider type="vertical" />
          <a @click="toResetStatus(render.staffId, render.isDeleted == 0?1:0)">{{ render.isDeleted == 0 ? "停用" : "启用" }}</a> -->
        </div>
        <a-row slot="footer" type="flex" justify="end">
          <a-pagination v-model="page" :page-size-options="pageSizeOptions" :total="total"
            :show-total="(total) => `共 ${total} 个用户`" show-size-changer :page-size="pageSize"
            @showSizeChange="onShowSizeChange" @change="pageChange" size="small">
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row>
      </a-table>
    </a-space>

    <a-modal v-model="showStaffInfoModal" :title="createFlag ? '新增员工' : '修改员工'" on-ok="submit">
      <a-form-model ref="createUserForm" :model="staffForm" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        <a-form-model-item label="用户名" required prop="name">
          <a-input v-model="staffForm.name" />
        </a-form-model-item>

        <a-form-model-item label="性别" required>
          <a-select v-model="staffForm.gender">
            <a-select-option key="0" value="0">
              女
            </a-select-option>
            <a-select-option key="1" value="1">
              男
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="科目授权" required>
          <a-select placeholder="请选择科目" :value="staffForm.projectId" @change="changeProject">
            <a-select-option :value="item.id || item.name" v-for="item in projectList" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-model-item>

      </a-form-model>
      <div slot="footer">
        <a-button type="primary" :loading="sumbitLoading" @click="createOrUpdate()">提交</a-button>
      </div>
    </a-modal>

    <a-modal v-model="showDeleteModal" @ok="deleteStaff()">
      <p>是否确认删除员工？</p>
    </a-modal>

  </div>
</template>

<script>
import { staff, project } from "@/request/api.js"

const columns = [
  {
    title: '序号',
    dataIndex: "index",
    align: 'center',
    width: '30px',
    customRender:(text, render, index) => `${index + 1}`
  },
  {
    title: "姓名",
    dataIndex: "name",
    align: "center",
    width: "120px"
  },
  {
    title: "登录账号",
    dataIndex: "loginCode",
    align: "center",
    width: "120px"
  },
  {
    title: "性别",
    dataIndex: "gender",
    width: "80px",
    align: "center",
    scopedSlots: { customRender: "gender" }
  },
  // {
  //   title: "是否启用",
  //   dataIndex: "isDeleted",
  //   align: "center",
  //   width: "120px",
  //   scopedSlots: { customRender: "enabled" }
  // },
  {
    title: "科目权限",
    dataIndex: "projectName",
    align: "center",
    width: "120px"
  },
  {
    title: "操作",
    key: "operation",
    width: "180px",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
]

export default {
  data() {
    return {
      data: [],
      columns,
      loading: false,
      page: 1,
      pageSize: 10,
      tableScroll: {},
      total: 0,
      fuzzyMap:{
        'name':''
      },
      pageSizeOptions: ["10", "20", "50"],
      staffForm: {
        gender: 1
      },
      rules: {
        name: [
          { required: true, message: "请填写用户名", trigger: "blur" }
        ]
      },
      sumbitLoading: false,
      selectedRowKeys: [],
      projectList:[],
      showDeleteModal: false,
      showStaffInfoModal:false, //展示员工信息窗口
      createFlag:true, //默认为新增用户
    }
  },
  created() {
  },
  mounted() {
    this.loadStaff()
    this.loadParentProject()
    this.tableScroll = { y: document.body.clientHeight - 300 }
  },
  methods: {
    loadStaff() {
      this.loading = true
      let params = {}
      
      if (this.page < 1) {
        this.page = 1
      }
      
      params.fuzzyMap = this.fuzzyMap;
      params.page = this.page - 1;
      params.size = this.pageSize;

      staff.queryAll(params)
        .then((response) => {
          let total = response.total
          let data = response.data
          let loading = false
          Object.assign(this, {
            data,
            total,
            loading
          })
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },

    /**
     * 查询可授权的科目信息
     */
    loadParentProject() {
      project.queryParent()
        .then((projectList) => {
          Object.assign(this, {
            projectList
          })
        })
    },

    /**
     * 选择科目授权
     */
    changeProject(projectId) {
      let staffForm = this.staffForm;
      let projectInfo = this.projectList.filter((item) => item.id == projectId)[0];
      staffForm.projectId = projectInfo.id;
      staffForm.projectName = projectInfo.name;
      Object.assign(this, {
        staffForm
      })
    },

    search() {
      this.loadStaff()
    },
    reset() {
      let fuzzyMap = {
        'name':'',
      }
      Object.assign(this, {
        fuzzyMap
      })
      this.search()
    },
    // toResetStatus(id, isDeleted) {
    //   staff.resetStatus(id, isDeleted)
    //     .then(() => {
    //       this.$message.success("重置员工状态成功")
    //       this.loadStaff()
    //     })
    //     .catch(() => {
    //       this.sumbitLoading = false
    //     })
    // },
    toResetPassword(id) {
      staff.resetPassword(id)
        .then(() => {
          this.$message.success("重置密码成功")
          this.loadStaff()
        })
    },
    
    onShowSizeChange(page, pageSize) {
      this.page = page
      this.pageSize = pageSize
      this.loadStaff()
    },
    pageChange() {
      this.loadStaff()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      console.log("selectedRowKeys", this.selectedRowKeys)
    },
    /**
     * 打开新增员工信息窗口
     */
    createStaff() {
      let staffForm = {
        name: "",
        gender: "1",
        staffLevel: 2,
        projectId: this.projectList[0].id,
        projectName: this.projectList[0].name,
      }
      let showStaffInfoModal = true
      let createFlag = true
      Object.assign(this, {
        staffForm,
        showStaffInfoModal,
        createFlag
      })
    },
    /**
     * 打开修改员工信息窗口
     * @param {*} staffForm 
     */
    modifyStaff(staffForm) {
      this.showStaffInfoModal = true;
      let copyInfo = {};
      Object.assign(copyInfo, staffForm)
      copyInfo.gender = "" + staffForm.gender;
      this.staffForm = copyInfo
      this.createFlag = false;
    },

    /**
     * 新增或更新员工信息
     */
    createOrUpdate() {
      if (this.createFlag) {
        this.$refs.createUserForm.validate((valid) => {
          if (valid) {
            this.sumbitLoading = true
            staff.addStaff(this.staffForm)
              .then(() => {
                this.$message.success("创建成功")
                let showStaffInfoModal = false
                let sumbitLoading = false
                Object.assign(this, {
                  showStaffInfoModal,
                  sumbitLoading
                })
                this.loadStaff()
              })
              .catch(() => {
                this.sumbitLoading = false
              })
          } else {
            this.$message.error("表单校验不通过")
            return false
          }
        })
      } else {
        this.sumbitLoading = true
        staff.updateStaffInfo(this.staffForm)
          .then(() => {
            this.$message.success("更新成功")
            let showStaffInfoModal = false
            let sumbitLoading = false
            Object.assign(this, {
              showStaffInfoModal,
              sumbitLoading
            })
            this.loadStaff()
          })
          .catch(() => {
            this.sumbitLoading = false
          })
      }
    },

    /**
     * 打开删除信息提示窗口
     */
    openDeleteModal() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warn('请选择需要删除的员工信息');
      } else {
        this.showDeleteModal = true
      }
    },

    /**
     * 删除信息
     */
    deleteStaff() {
      staff.delete(this.selectedRowKeys)
      .then(() => {
        this.$message.success("删除成功")
        this.showDeleteModal = false
        this.loadStaff()
      })
    },
    update(staffForm) {
      console.log("update staffFrom=",staffForm)
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrap
    display flex
</style>
